
        <div class="row" [hidden]="msgHead.msg == ''">
            <div class="col-lg-8 col-md-6 col-xs-12">
                <alert [alert]="msgHead"></alert>
            </div>
        </div>
        <div *ngIf="hasAccess" class="row">
            <div class="col-lg-12 col-md-12 col-xs-12" style="padding:0px; margin-bottom:0px;">
                <form [formGroup]="form" novalid>
                    <div class="row">
                        <div class="col-lg-3 col-md-6 col-xs-12" style="margin-bottom: 0px;">
                            <div class="form-group">
                                <p class="custom-label">One Roster API URL</p>
                                <input type="text" [(ngModel)]="data.oneRosterApiUrl" formControlName="oneRosterApiUrl" class="form-control" placeholder="One Roster API URL" title="One Roster API URL">
                            </div>
							<div class="form-group">
								<p class="custom-label">One Roster API Version</p>
								<select [(ngModel)]="data.oneRosterApiVersion" formControlName="oneRosterApiVersion" class="form-control" title="One Roster API Version">
									<option *ngFor="let orv of oneRosterApiVersions; let i = index" [value]="orv.id">{{orv.title}}</option>
								</select>
							</div>
                            <div class="form-group">
                                <p class="custom-label">OAuth Client ID</p>
                                <input type="text" [(ngModel)]="data.oauthClientId" formControlName="oauthClientId" class="form-control" placeholder="OAuth Client ID" title="OAuth Client ID">
                            </div>
                            <div class="form-group">
                                <p class="custom-label">OAuth Client Secret</p>
                                <input type="text" [(ngModel)]="data.oauthClientSecret" formControlName="oauthClientSecret" class="form-control" placeholder="OAuth Client Secret" title="OAuth Client Secret">
									 </div>
                            <div class="form-group">
                                <p class="custom-label">Authorization</p>
                                <select [(ngModel)]="data.oauthVersion" formControlName="oauthVersion" class="form-control" title="Authorization">
                                    <option *ngFor="let oa of oauthVersions; let i = index" [value]="oa.id">{{oa.title}}</option>
                                </select>
                            </div>
									 <div *ngIf="data.oauthVersion=='oauth-2.0-bearer-token'" class="form-group">
                                <p class="custom-label">OAuth Token Endpoint URL</p>
                                <input type="text" [(ngModel)]="data.oauthTokenEndpoint" formControlName="oauthTokenEndpoint" class="form-control" placeholder="OAuth Token Endpoint URL" title="OAuth Token Endpoint URL">
									 </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-lg-12 col-md-12 col-xs-12" style="margin-top:0px;">
                <button type="button" class="btn btn-large btn-primary" (click)="save()">Save</button>
                <a style="margin-left:10px;cursor: pointer;" (click)="goBack()">Go Back</a>
            </div>
	    </div>
        <div *ngIf="hasAccess" class="row">
            <div class="col-lg-6 col-md-6 col-xs-12">
                <alert [alert]="msg" style="display:block;"></alert>
            </div>
        </div>
    